import { connect } from 'react-redux'
import ApplicantsDriveLevel from 'modules/Report/Partials/ApplicantsDriveLevel/index.js'
import {
  cityDetails,
  tierDetails,
  collegeDetails,
  roleDetails,
  getApplicationDriveLevel,
  roundDetails,
  courseTypeDetails,
  degreeDetails,
  statusDetails,
} from 'modules/Report/action.js'
import { getListOfDegree } from 'modules/Roles/actions'
import rolesSelectors from 'modules/Roles/selectors'
import reportSelectors from 'modules/Report/selectors.js'
import authSelector from 'modules/Auth/selectors'
const mapStateToProps = state => ({
  cityData: reportSelectors.getCityData(state),
  tierData: reportSelectors.getTierData(state),
  collegeData: reportSelectors.getCollegeData(state),
  roleData: reportSelectors.getRoleData(state),
  roundData: reportSelectors.getRoundData(state),
  degreeData: reportSelectors.getDegreeData(state),
  courseTypeData: reportSelectors.getCourseTypeData(state),
  rolesPublishedData: reportSelectors.getApplicationDriveLevel(state),
  excelDataForReport: reportSelectors?.excelData(state),
  listOfDegree: rolesSelectors.getListOfDegree(state),
  corporateData: authSelector.getCorporateData(state),
  statusData: reportSelectors.getStatusData(state),
})

const mapDispatchToProps = {
  cityDetails,
  tierDetails,
  getApplicationDriveLevel,
  collegeDetails,
  roleDetails,
  roundDetails,
  courseTypeDetails,
  degreeDetails,
  getListOfDegree,
  statusDetails,
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicantsDriveLevel)
